module.exports = __webpack_public_path__ + "img/cancel.c4a04ae8.svg";